import { styled, Stack } from '@mui/material';

export const ConfigLogisticZoneFormContent = styled(Stack)({
  overflow: 'hidden',
  height: '100%',
  maxHeight: 'calc(100vh - 256px)',
  minHeight: 'calc(100vh - 256px)',
});

export const ConfigLogisticZoneFormInputsContent = styled(Stack)(
  ({ theme }) => ({
    overflowY: 'auto',
    paddingRight: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
  }),
);

export const ConfigLogisticZoneFormMapContainer = styled('div')({
  width: '100%',
  height: '100%',

  '& .mapboxgl-map': {
    borderRadius: 10,
  },
});
